import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import AdditionalInfoStep from './AdditionalInfoStep';
import { ADDITIONAL_STEP } from './copy';

const DRAFT = {
  address1: '',
  address2: '',
  city: '',
  countryCode: '',
  fax: '',
  phone: '',
  postalCode: '',
  state: '',
};

const COUNTRIES = [
  { id: 'US', label: 'United States' },
  { id: 'MX', label: 'Mexico' },
];

const onChange = jest.fn();
const onChangeCountry = jest.fn();

const renderStep = (props = {}) =>
  render(
    <ConfigProvider>
      <AdditionalInfoStep
        countryOptions={COUNTRIES}
        draft={DRAFT}
        stateOptions={[]}
        onChange={onChange}
        onChangeCountry={onChangeCountry}
        {...props}
      />
    </ConfigProvider>,
  );

beforeEach(() => {
  onChange.mockClear();
  onChangeCountry.mockClear();
});

describe('management/Users AdditionalInfoStep', () => {
  it('says every field is optional', () => {
    renderStep();

    expect(screen.getByText(ADDITIONAL_STEP.subtitle)).toBeInTheDocument();
  });

  // Every field here is optional, so the "Required Fields" key would be a lie.
  it('omits the required-fields key', () => {
    renderStep();

    expect(screen.queryByText('Required Fields')).not.toBeInTheDocument();
  });

  it('reports what the admin types', () => {
    renderStep();

    fireEvent.change(screen.getByLabelText(ADDITIONAL_STEP.city), {
      target: { value: 'Richmond' },
    });

    expect(onChange).toHaveBeenCalledWith('city', 'Richmond');
  });

  // From the designer's sticky note: the states offered depend on the country, so
  // there is nothing to choose from until one is picked.
  //
  // Asserted by behaviour rather than the disabled attribute, because KeyDS
  // Select's Target strips `disabled` off its trigger button and only gates the
  // click on the field container.
  it('does not open the State list until a Country is chosen', () => {
    renderStep();

    fireEvent.click(screen.getByLabelText(ADDITIONAL_STEP.state));

    expect(screen.queryByText('Virginia')).not.toBeInTheDocument();
  });

  it('opens the State list once its country has states', async () => {
    renderStep({
      draft: { ...DRAFT, countryCode: 'US' },
      stateOptions: [{ id: 'VA', label: 'Virginia' }],
    });

    fireEvent.click(screen.getByLabelText(ADDITIONAL_STEP.state));

    expect(await screen.findByText('Virginia')).toBeInTheDocument();
  });

  it('warns when a country is chosen but a state is not', () => {
    renderStep({
      draft: { ...DRAFT, countryCode: 'MX' },
      isStateMissing: true,
      stateOptions: [{ id: 'JAL', label: 'Jalisco' }],
    });

    expect(screen.getByText(ADDITIONAL_STEP.stateMissing)).toBeInTheDocument();
  });

  it('does not warn before a country is chosen', () => {
    renderStep();

    expect(
      screen.queryByText(ADDITIONAL_STEP.stateMissing),
    ).not.toBeInTheDocument();
  });

  // portal.users has only mobile_country_code, so there is nowhere to store a
  // calling code for these two — the mockup's selects would do nothing.
  it('gives Phone and Fax no country code select', () => {
    renderStep();

    expect(screen.getByLabelText(ADDITIONAL_STEP.phone)).toBeInTheDocument();
    expect(screen.getByLabelText(ADDITIONAL_STEP.fax)).toBeInTheDocument();
    expect(screen.queryByLabelText('Country Code')).not.toBeInTheDocument();
  });
});
